export const cdnRegex = {
    liquidpixel: /(http:)?\/\/lp2\.hm\.com\/hmgoep(prod|dev)/,
    akamai: /(http:)?\/\/image\.hm\.com\/assets\/hm/,
};
//# sourceMappingURL=constants.js.map